import request from '../utils/request';

export interface Order {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  specialInstructions: string;
  whereWillTheTreeBeLeft: string;
  collectionAddress: string;
  donation: number;
  quantity: number;
  area: string;
}

export interface CreateOrderPayload {
  payment: {
    token: string;
    verificationToken: string;
  };
  order: Order;
}

export async function submitTreeCollectionRequest({
  payment: { token, verificationToken },
  order: {
    firstName,
    lastName,
    email,
    phone,
    specialInstructions,
    whereWillTheTreeBeLeft,
    collectionAddress,
    donation,
    quantity,
    area
  }
}: CreateOrderPayload) {
  try {
    return request('/api/order/tree-collection', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sourceId: token,
        verificationToken,
        firstName,
        lastName,
        email,
        phone,
        specialInstructions,
        whereWillTheTreeBeLeft,
        collectionAddress,
        donation,
        quantity,
        area
      })
    });
  } catch (error) {
    throw new Error(error);
  }
}
